import styled from 'styled-components';

export const PanelWrapper = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: ${({ bgColor }) => bgColor};
`;

export const ContentArea = styled.div`
    height: 100%;
    overflow: auto;
`;

export const DesktopAppContainer = styled.div`
    position: relative;
    margin: 20px;
    box-shadow: 5px 5px 5px #bbb;

    /* Page-specific styles */
    width: ${({ pageAttrs }) => pageAttrs.width}px;
    height: ${({ pageAttrs }) => pageAttrs.height}px;
    background-color: ${({ pageAttrs }) => pageAttrs.backgroundColor || '#ffffff'};
    background-image: ${({ pageAttrs }) => pageAttrs.backgroundImage};
    background-repeat: ${({ pageAttrs }) => pageAttrs.backgroundRepeat};
    background-position: ${({ pageAttrs }) => pageAttrs.backgroundPosition};
    background-size: ${({ pageAttrs }) => pageAttrs.backgroundSize};

    /* App-level frame styles */
    border: ${({ frameStyles }) => frameStyles.border};
    border-radius: ${({ frameStyles }) => frameStyles.borderRadius};

    outline: ${({ isOver, canDrop }) => (isOver && canDrop ? '3px dashed #F89B3C' : 'none')};
    outline-offset: -4px;
`;

export const Tooltip = styled.div.attrs(props => ({
    style: {
        top: `${props.y}px`,
        left: `${props.x}px`,
    },
}))`
    position: fixed;
    background-color: #f5f5f5;
    color: #000;
    border: 1px solid #ccc;
    padding: 5px 10px;
    border-radius: 4px;
    font-size: 12px;
    z-index: 1000;
    pointer-events: none;
    transform: translate(10px, 10px);
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
`;